import * as studioSmall from './static/environments/studio_small_08_4k.env';

export const ENVIRONMENTS = {
  defaultEnvironments: [
    {
      id: 'default',
      name: 'Default',
      imageURL: null,
      envURL: studioSmall.default,
    },
  ],
};